'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.transposeVNode = transposeVNode;

var _most = require('most');

function createVTree(vNode, children) {
  return {
    sel: vNode.sel,
    data: vNode.data,
    text: vNode.text,
    elm: vNode.elm,
    key: vNode.key,
    children: children
  };
}

function transposeVNode(vNode) {
  // eslint-disable-line complexity
  if (vNode && vNode.data && vNode.data.static) {
    return (0, _most.just)(vNode);
  } else if (typeof vNode.observe === 'function') {
    return vNode.map(transposeVNode).switch();
  } else if (vNode !== null && (typeof vNode === 'undefined' ? 'undefined' : _typeof(vNode)) === 'object') {
    if (!vNode.children || vNode.children.length === 0) {
      return (0, _most.just)(vNode);
    }

    return (0, _most.combineArray)(function () {
      for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
        children[_key] = arguments[_key];
      }

      return createVTree(vNode, children);
    }, vNode.children.map(transposeVNode));
  } else {
    throw new TypeError('transposition: Unhandled vNode type');
  }
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/transposition.js
 **/